<template lang="pug">
v-btn(
  icon
  :disabled="disabled"
  @click.stop="onClick")
  v-icon(color="green accent-4" v-text="`$vuetify.icons.themeResult`")
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick () {
      this.$emit('click')
    },
  }
}
</script>
